export default {
 BT_HDP: "แฮนดีแคพ | HDP",
  BT_OU: "สูงกว่า ต่ำกว่า | O/U",
  BT_ML: "มันนี่ไลน์",
  BT_1X2: "1X2",
  BT_1X2HDP: "แฮนดิแคป 3 ทาง",
  BT_CS: "คะแนนที่ถูกต้อง",
  BT_OE: "คู่ คี่  | คี่/คู่",
  BT_DC: "สองโอกาส",
  BT_HTFT: "ครึ่งเวลา / เต็มเวลา",
  BT_FGLG: "โกลแรก / สุดท้าย",
  BT_TG: "จำนวนโกลทั้งหม",
  BT_OR: "ผลชนะเลิศ",
  BT_ORZ: "ผลชนะเลิศ",

  BT_ANB: "ไม่มีการวางเดิมพันทีมเยือน",
  BT_BS: "ทั้งสองทีม/หนึ่งทีม/ไม่มีทีมใดที่ทำคะแนนได้",
  BT_CL: "ไม่เสียประตู",
  BT_DNB: "เสมอไม่เดิมพัน",
  BT_HNB: "ไม่มีการวางเดิมพันทีมเหย้า",
  BT_TWTN: "ชนะโดยไม่เสียประตู",

  BT_HDPF: "เต็มเวลา แฮนดีแคพ | เต็มเวลา. HDP",
  BT_OUF: "เต็มเวลา สูงกว่า ต่ำกว่า | เต็มเวลา O/U",
  BT_MLF: "เต็มเวลา มันนี่ไลน์",
  BT_1X2F: "เต็มเวลา 1X2",
  BT_1X2HDPF: "เต็มเวลา แฮนดิแคป 3 ทาง",
  BT_CSF: "เต็มเวลา คะแนนที่ถูกต้อง",
  BT_OEF: "เต็มเวลา คี่ คู่",
  BT_DCF: "เต็มเวลา สองโอกาส",
  BT_FGLGF: "เต็มเวลา โกลแรก / สุดท้าย",
  BT_TGF: "เต็มเวลา จำนวนโกลทั้งหม",

  BT_HDPH: "ครึ่งเวลา แฮนดีแคพ | ครึ่งเวลา. HDP",
  BT_OUH: "ครึ่งเวลา สูงกว่า ต่ำกว่า | ครึ่งเวลา O/U",
  BT_MLH: "ครึ่งเวลา มันนี่ไลน์",
  BT_1X2H: "ครึ่งเวลา 1X2",
  BT_1X2HDPH: "ครึ่งเวลา แฮนดิแคป 3 ทาง",
  BT_CSH: "ครึ่งเวลา คะแนนที่ถูกต้อง",
  BT_OEH: "ครึ่งเวลา คี่ คู่",
  BT_DCH: "ครึ่งเวลา สองโอกาส",
  BT_FGLGH: "ครึ่งเวลา โกลแรก / สุดท้าย",
  BT_TGH: "ครึ่งเวลา จำนวนโกลทั้งหม",

  BT_HDPOU: "แฮนดิแคป & มากกว่า/น้อยกว่า",
  BT_PARLAY: "มิกซ์ พาร์เลย์",
  BT_FT: "เต็มเวลา. ",
  BT_1H: "ครึ่งแรก. ",
  BT_2H: "ครึ่งหลัง. ",

  BT_FG: "ประตูแรก",
  BT_LG: "ประตูสุดท้าย",
  BT_HFG: "HFG",
  BT_AFG: "AFG",
  BT_HLG: "HLG",
  BT_ALG: "ALG",
  BT_NG: "ไม่มีประตู",
  BT_HY: "เจ้าบ้าน ไม่เสียประ",
  BT_HN: "เจ้าบ้าน เสียประตู",
  BT_AY: "ทีมเยือน ใช",
  BT_AN: "ทีมเยือน เสียประตู",
  BT_H: "เจ้าบ้าน",
  BT_A: "ทีมเยือน",
  BT_D: "เสมอกัน",
  BT_HD_DC: "HD",
  BT_HA_DC: "HA",
  BT_DA_DC: "DA",
  BT_HH: "HH",
  BT_HD: "HD",
  BT_HA: "HA",
  BT_DH: "DH",
  BT_DD: "DD",
  BT_DA: "DA",
  BT_AH: "AH",
  BT_AD: "AD",
  BT_AA: "AA",

  BT_Y: "ใช่",
  BT_N: "ไม่มี",

  BT_LIVE: "สดๆ",
  BT_HT: "ครึ่งแรก",
  BT_DELAYED: "DELAY",
  BT_PEN: "PEN",

  BT_FT1: "เต็มเวลา.1",
  BT_FT2: "เต็มเวลา.2",
  BT_FTX: "เต็มเวลา.X",
  BT_HT1: "ครึ่งเวลา.1",
  BT_HT2: "ครึ่งเวลา.2",
  BT_HTX: "ครึ่งเวลา.X",

  BT_BOTH: "ทั้งคู่",
  BT_ONE: "หนึ่ง",
  
  LOT_BS: "ใหญ่/เล็ก",
  LOT_BIG: "ใหญ่",
  LOT_SMALL: "เล็ก",
  LOT_OE: "คี่/คู่",
  LOT_ODD: "คี่",
  LOT_EVEN: "คู่",
  LOT_OU: "าสูง/ต่ำ",
  LOT_OVER: "าสูง",
  LOT_UNDER: "ต่ำ",

  BT_ALL: "@:ui.bet_list",

  BT_HDPMMO: "HDPMMO",
  BT_OUMMO: "OUMMO"
};